import Paragraph from "@common/components/Paragraph/Paragraph";
import Tooltip from "@common/components/Tooltip/Tooltip";
import { vars } from "@common/styles";
import styled, { css, CSSProperties } from "styled-components";

export const CopyAction = styled(Tooltip)`
  width: auto;
  display: inline-flex;
  flex-shrink: 0;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.2s ease;

  &:focus-within {
    opacity: 1;
    pointer-events: auto;
  }
`;

export const EndpointUrlRoot = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0.6rem;
  flex: 1;
  min-width: 0;

  &:hover ${CopyAction} {
    opacity: 1;
    pointer-events: auto;
  }
`;

export const UrlTooltip = styled(Tooltip)`
  width: auto;
  flex: 0 1 auto;
  min-width: 0;
`;

export const EndpointUrl = styled(Paragraph)<{ $isError?: boolean; $compact?: boolean }>`
  color: ${({ $isError }) => ($isError ? vars.colors.red : vars.colors.grey30)};
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;

  ${({ $compact, $isError }) =>
    $compact &&
    css`
      font-size: 1.3rem;
      color: ${$isError ? vars.colors.red : vars.colors.grey30};
    `}
`;

export const Origin = styled.span<{ $isError?: boolean }>`
  color: ${({ $isError }) => ($isError ? vars.colors.red : vars.colors.grey70)};
`;

export const Separator = styled.span<{ $isError?: boolean }>`
  color: ${({ $isError }) => ($isError ? vars.colors.red : vars.colors.grey30)};
`;

export const ParamBadge = styled.span<{ $isError?: boolean; $compact?: boolean }>`
  display: inline-flex;
  align-items: center;
  height: 1.8rem;
  vertical-align: top;
  margin: 0 0.4rem;

  &::before {
    content: "*";
    display: flex;
    align-items: center;
    justify-content: center;
    width: 1.8rem;
    height: 1.4rem;
    border-radius: 1.2rem;
    border: 1px solid ${vars.colors.grey80};
    background: ${vars.colors.grey100};
    color: ${({ $isError }) => ($isError ? vars.colors.red : vars.colors.grey30)};
    font-size: 1.6rem;
    line-height: 1;
    padding-top: 0.257em;
  }
`;

export const CopyButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;

  width: 2.4rem;
  height: 2.4rem;
  padding: 0;

  border: 1px solid ${vars.colors.grey80};
  border-radius: 0.5rem;
  background: ${vars.colors.grey100};
  cursor: pointer;
  transition: ${vars.transitions.hover};

  svg {
    width: 1.6rem;
    height: 1.6rem;

    path {
      stroke: ${vars.colors.grey50};
    }
  }

  &:hover {
    background: ${vars.colors.grey90};

    svg path {
      stroke: ${vars.colors.grey30};
    }
  }
`;

/*
 * The URL tooltip is portaled out of the cards (which are overflow: hidden), so its
 * content is no longer a descendant of the wrapper above and cannot be styled from
 * there. Endpoint URLs also outrun the tooltip's default 500px nowrap line, so let it
 * wrap — URLs have no spaces, hence overflow-wrap: anywhere.
 */
export const urlTooltipContentStyle: CSSProperties = {
  whiteSpace: "normal",
  overflow: "visible",
  textOverflow: "clip",
  overflowWrap: "anywhere",
  textAlign: "left",
};
